import back from "@/components/backButton";
import List from "@/components/swiperList";

const backButton = {
    install:function(Vue){
        //第一个参数是name 第二个是引入的组件
        Vue.component('backButton',back)
    }
}
const swiperList = {
    install:function(Vue){
        //第一个参数是name 第二个是引入的组件
        Vue.component('swiperList',List)
    }
}
export {
    backButton,
    swiperList
};